import React, { useState } from 'react';
import { Input, InputProps } from 'semantic-ui-react';
import { useURLState } from 'src/hooks';
import { useDebounce, useUpdateEffect } from 'ahooks';

type Props = {
  extra?: React.ReactElement;
  onSearchResult?: <T extends SearchParams.Base>(
    query: T,
  ) => void | Promise<any>;
  onSearchChange?: (text: string) => Object;
  searchKey?: string;
} & InputProps;

const Search: React.FC<Props> = ({
  extra,
  onSearchResult,
  onSearchChange,
  searchKey = 'q',
  ...rest
}) => {
  const [search, setSearch] = useURLState<SearchParams.Base>({});
  const debouncedSearch = useDebounce(search, { wait: 500 });
  const [loading, setLoading] = useState<boolean>(false);

  useUpdateEffect(() => {
    const fetch = async () => {
      setLoading(true);
      await onSearchResult?.(debouncedSearch);
      setLoading(false);
    };

    fetch();
  }, [debouncedSearch[searchKey]]);

  const handleSearchChange: InputProps['onChange'] = (e, d) => {
    setSearch({ ...search, [searchKey]: e.target.value });
  };

  return (
    <div className="d-flex mb-24">
      <Input
        fluid
        loading={loading}
        className="flex-1"
        placeholder="Search"
        value={search[searchKey] || ''}
        onChange={handleSearchChange}
        icon={
          search[searchKey]
            ? {
                name: 'close',
                link: true,
                onClick: (e) => setSearch({ ...search, [searchKey]: '' }),
              }
            : undefined
        }
        {...rest}
      />
      {extra}
    </div>
  );
};

export default Search;
